<template>
  <div v-if="address">
    <div class="title mb-2 text-uppercase">
      {{ $t("transaction_detail_delivery.title") }}
    </div>
    <div>
      {{ address.name }}
    </div>
    <div>
      {{ address.address }}
    </div>
    <div>
      {{ address.postal_code }} {{ address.town }}
    </div>
    <div>
      {{ countryName(address.country) }}
    </div>
    <div>
      {{ address.phone }}
    </div>
  </div>
</template>


<script>
import { getCountryName } from "@/lib/country";

export default {
  name: "transaction-detail-delivery",
  props: {
    address: {
      type: Object,
      default: undefined,
    },
  },
  methods: {
    countryName(countryCode) {
      return getCountryName(countryCode);
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        transaction_detail_delivery: {
          title: "Delivery info",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.title {
  font-weight: bold;
}
</style>
